import { useState } from "react";

// @mui material components

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar/custom_nobreadcrumb";
import Footer from "examples/Footer";

import DataTable from "examples/Tables/DataTable";

// Data
import dataTableData from "./table";

function OrderList() {
  const [menu, setMenu] = useState(null);

  const openMenu = (event) => setMenu(event.currentTarget);
  const closeMenu = () => setMenu(null);

  const renderMenu = (
    <Menu
      anchorEl={menu}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      open={Boolean(menu)}
      onClose={closeMenu}
      keepMounted
    >
      <MenuItem onClick={closeMenu}>Status: Paid</MenuItem>
      <MenuItem onClick={closeMenu}>Status: Refunded</MenuItem>
      <MenuItem onClick={closeMenu}>Status: Canceled</MenuItem>
      <Divider sx={{ margin: "0.5rem 0" }} />
      <MenuItem onClick={closeMenu}>
        <MDTypography variant="button" color="error" fontWeight="regular">
          Remove Filter
        </MDTypography>
      </MenuItem>
    </Menu>
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox my={3}>

      {/*<MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
        <MDBox display="flex">
          <MDButton
            variant="gradient"
            color="info"
            onClick={() =>
              (window.location.href =
                "https://amplifysolar05c28e3aa82b7a41d9bef2b57aeb702074679c7-dev.s3.us-east-1.amazonaws.com/csv/SolarSentimentCities2013_2022.zip")
            }
          >
            Download Datasets (City-Level)
          </MDButton>
          {renderMenu}
        </MDBox>
      </MDBox>*/}
      
      {/*<MDBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={2}>
        <MDBox display="flex">
          <MDButton
            variant="gradient"
            color="info"
            onClick={() =>
              (window.location.href =
                "https://amplifysolar05c28e3aa82b7a41d9bef2b57aeb702074679c7-dev.s3.us-east-1.amazonaws.com/csv/SolarSentimentStates2013_2022.zip")
            }
          >
            Download Datasets (State-Level)
          </MDButton>
          {renderMenu}
        </MDBox>
      </MDBox>*/}
        <DataTable table={dataTableData} entriesPerPage={false} canSearch />
      </MDBox>


      <Footer />
    </DashboardLayout>
  );
}

export default OrderList;
